import api from './api';

class OfferService {

    getOffers() {
      return api.get('offers/activeList');
    }
  }
  export default new OfferService();